import React from "react";
import { Link } from "react-router-dom";
import ProductGrid from "../components/ProductGrid";
import PromoStrip from "../components/PromoStrip";
import { Briefcase, Handshake, ArrowRight, TrendingUp, Truck, Percent } from "lucide-react";

const PARTNERSHIP_MSG = "Hola, me interesa explorar una alianza comercial con Torvi Accesorios. Me gustaría conocer las condiciones y propuestas.";
const PARTNERSHIP_URL = "https://wa.me/56975359774?text=" + encodeURIComponent(PARTNERSHIP_MSG);

export default function Emprende() {
  return (
    <>
      <PromoStrip />

      {/* Hero Emprende */}
      <section className="relative overflow-hidden hero-gradient" data-testid="emprende-hero">
        <div className="relative max-w-7xl mx-auto px-5 md:px-8 lg:px-12 py-16 md:py-20">
          <div className="grid lg:grid-cols-12 gap-10 items-center">
            <div className="lg:col-span-7">
              <div className="inline-flex items-center gap-2 bg-white border border-sky-200 px-3 py-1.5 rounded-full text-xs font-bold text-sky-700 mb-5">
                <Briefcase size={13} /> Para emprendedores
              </div>
              <h1 className="font-heading font-black text-5xl sm:text-6xl tracking-tighter leading-[0.95] text-black">
                Emprende con <span className="text-[#0EA5E9]">Torvi</span>
              </h1>
              <p className="mt-5 text-lg text-slate-600 max-w-xl leading-relaxed">
                Lleva la personalización de fundas a tu propio negocio. Compra al por mayor, accede a precios especiales
                y construye tu marca con nuestra calidad de fábrica.
              </p>
              <div className="mt-7 flex flex-wrap gap-3">
                <a href="#productos-mayor" className="btn-primary inline-flex items-center gap-2" data-testid="emprende-cta-mayor">
                  Ver pack mayorista <ArrowRight size={16} />
                </a>
                <a
                  href={PARTNERSHIP_URL}
                  target="_blank"
                  rel="noreferrer"
                  className="btn-outline-dark inline-flex items-center gap-2"
                  data-testid="emprende-alianzas-btn"
                >
                  <Handshake size={16} /> Alianzas comerciales
                </a>
              </div>

              <div className="mt-10 grid sm:grid-cols-3 gap-3">
                <Bullet icon={<Percent size={16} />} title="Precios mayorista" text="Descuentos al comprar packs" />
                <Bullet icon={<Truck size={16} />} title="Envíos consolidados" text="Logística simplificada a todo Chile" />
                <Bullet icon={<TrendingUp size={16} />} title="Crecimiento" text="Reposición rápida según tu demanda" />
              </div>
            </div>
            <div className="lg:col-span-5">
              <div className="relative aspect-[4/5] rounded-3xl overflow-hidden border border-slate-200 bg-white shadow-2xl tech-glow">
                <img
                  alt="Pack mayorista de fundas Torvi"
                  src="https://images.unsplash.com/photo-1556656793-08538906a9f8?w=900&q=85"
                  className="w-full h-full object-cover"
                />
                <div className="absolute inset-0 bg-gradient-to-t from-black/40 to-transparent" />
                <div className="absolute bottom-5 left-5 right-5 glass rounded-2xl p-4">
                  <div className="text-xs uppercase tracking-widest font-bold text-slate-500">Pack 12 unidades</div>
                  <div className="font-heading font-bold text-black">Empieza tu negocio hoy</div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* Alianzas comerciales banner */}
      <section className="py-10 bg-black text-white" data-testid="emprende-alianzas-section">
        <div className="max-w-7xl mx-auto px-5 md:px-8 lg:px-12 flex flex-col md:flex-row items-start md:items-center justify-between gap-5">
          <div>
            <div className="inline-flex items-center gap-2 text-xs uppercase tracking-[0.25em] font-bold text-sky-400">
              <Handshake size={14} /> Alianzas comerciales
            </div>
            <h2 className="font-heading font-black text-3xl md:text-4xl mt-2 leading-tight">
              ¿Tienes una tienda, marca o emprendimiento?
            </h2>
            <p className="text-slate-300 mt-2 max-w-2xl">
              Buscamos socios que quieran sumar fundas personalizadas a su catálogo. Trabajemos juntos: te ayudamos con
              diseño, producción y reposición.
            </p>
          </div>
          <a
            href={PARTNERSHIP_URL}
            target="_blank"
            rel="noreferrer"
            className="btn-primary inline-flex items-center gap-2 whitespace-nowrap"
            data-testid="emprende-alianzas-cta"
          >
            <Handshake size={17} /> Hablar de alianzas
          </a>
        </div>
      </section>

      <div id="productos-mayor">
        <ProductGrid
          defaultCategory="emprende"
          hideFilters
          title="Productos para emprendedores"
          subtitle="Packs al por mayor con descuento especial."
        />
      </div>
    </>
  );
}

const Bullet = ({ icon, title, text }) => (
  <div className="bg-white border border-slate-200 rounded-2xl p-4">
    <div className="w-9 h-9 rounded-lg bg-sky-50 text-[#0EA5E9] flex items-center justify-center">{icon}</div>
    <div className="font-heading font-bold mt-3">{title}</div>
    <div className="text-sm text-slate-600 mt-1">{text}</div>
  </div>
);
